import React, { useMemo } from "react"
import classNames from "classnames"

import styles from "./index.module.less"

interface IProps {
    className?: string
    style?: React.CSSProperties
    label: string
    subLabel?: string
}

const PartTitle: React.FC<IProps> = (props) => {
    const { className, style, label, subLabel } = props

    const subLabelNode = useMemo(() => {
        const parts = subLabel?.split(" ")

        return parts?.map((part, index) => (
            <div key={index} className={styles.part}>
                <span>{part}</span>
            </div>
        ))
    }, [subLabel])

    return (
        <div className={classNames(styles.partTitle, className)} style={style}>
            <div className={styles.subLabel}>{subLabelNode}</div>
            <div className={styles.label}>{label}</div>
        </div>
    )
}

export default PartTitle
